<template>
  <footer class="site-footer">
    <div class="footer-cta">
      <span>Software Development Partner</span>
      <h2>有软件开发需求？我们帮你把想法变成可上线系统。</h2>
      <router-link to="/contactus">获取开发方案</router-link>
    </div>

    <div class="footer-main">
      <div class="footer-brand">
        <div class="brand-row">
          <span class="brand-mark">PL</span>
          <div>
            <strong>攀临科技</strong>
            <small>企业软件开发与数字化解决方案</small>
          </div>
        </div>
        <p>专注官网建设、后台管理系统、APP、小程序、数据平台、AI 应用与系统集成开发，提供从需求到上线的完整交付服务。</p>
        <div class="company-entities">
          <span>服务主体</span>
          <strong>茂名攀临网络科技有限公司</strong>
          <strong>广州君邻科技有限公司</strong>
        </div>
        <div class="contact-list">
          <a href="tel:15622317013">15622317013</a>
          <a href="mailto:1097701453@qq.com">1097701453@qq.com</a>
          <span>茂名市茂南区高凉中路</span>
        </div>
      </div>

      <div class="footer-cols">
        <div class="footer-col">
          <h4>开发服务</h4>
          <router-link to="/service">企业管理系统</router-link>
          <router-link to="/service">网站与官网建设</router-link>
          <router-link to="/service">APP / 小程序开发</router-link>
          <router-link to="/service">数据平台开发</router-link>
        </div>
        <div class="footer-col">
          <h4>软件产品</h4>
          <router-link to="/software/smartTown">车辆管理系统</router-link>
          <router-link to="/software/bigData">大数据管理系统</router-link>
          <router-link to="/software">定制软件方案</router-link>
        </div>
        <div class="footer-col">
          <h4>公司信息</h4>
          <router-link to="/companyintroduction">关于团队</router-link>
          <router-link to="/newsinformation">案例资讯</router-link>
          <router-link to="/jobchance">加入我们</router-link>
          <router-link to="/contactus">联系我们</router-link>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2024 茂名攀临网络科技有限公司 / 广州君邻科技有限公司. All rights reserved.</span>
      <button type="button" @click="scrollToTop" :class="{ visible: showBackToTop }">返回顶部</button>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      showBackToTop: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.site-footer {
  color: #f5f5f7;
  background: #050505;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.footer-cta {
  padding: 110px 24px;
  text-align: center;
  background: radial-gradient(circle at 50% 0%, rgba(138,180,255,0.42), transparent 44%), #050505;
}

.footer-cta span {
  display: inline-block;
  margin-bottom: 16px;
  color: #8ab4ff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.footer-cta h2 {
  max-width: 820px;
  margin: 0 auto 30px;
  font-size: clamp(30px, 4vw, 54px);
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -0.05em;
}

.footer-cta a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 24px;
  border-radius: 999px;
  color: #050505;
  background: #fff;
  font-size: 15px;
  font-weight: 800;
  text-decoration: none;
}

.footer-main {
  max-width: 1180px;
  margin: 0 auto;
  padding: 76px 24px;
  display: grid;
  grid-template-columns: 1.05fr 1.2fr;
  gap: 70px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}

.brand-mark {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #050505;
  background: linear-gradient(135deg, #fff, #9ec5ff);
  font-weight: 900;
}

.brand-row strong,
.brand-row small {
  display: block;
}

.brand-row strong {
  font-size: 20px;
}

.brand-row small {
  margin-top: 4px;
  color: rgba(255,255,255,0.46);
  font-size: 13px;
}

.footer-brand p {
  max-width: 460px;
  margin: 0 0 24px;
  color: rgba(255,255,255,0.58);
  font-size: 15px;
  line-height: 1.8;
}

.company-entities {
  display: grid;
  gap: 7px;
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 18px;
  background: rgba(255,255,255,0.045);
  border: 1px solid rgba(255,255,255,0.08);
}

.company-entities span {
  color: rgba(255,255,255,0.42);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.company-entities strong {
  color: rgba(255,255,255,0.78);
  font-size: 14px;
  font-weight: 750;
}

.contact-list {
  display: grid;
  gap: 10px;
}

.contact-list a,
.contact-list span,
.footer-col a {
  color: rgba(255,255,255,0.58);
  font-size: 14px;
  text-decoration: none;
}

.contact-list a:hover,
.footer-col a:hover {
  color: #fff;
  text-decoration: none;
}

.footer-cols {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 34px;
}

.footer-col h4 {
  margin: 0 0 18px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
}

.footer-col a {
  display: block;
  margin-bottom: 12px;
}

.footer-bottom {
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 24px 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.42);
  font-size: 13px;
}

.footer-bottom button {
  border: 1px solid rgba(255,255,255,0.16);
  border-radius: 999px;
  padding: 8px 14px;
  color: rgba(255,255,255,0.68);
  background: rgba(255,255,255,0.04);
  transition: all 0.2s ease;
}

.footer-bottom button.visible,
.footer-bottom button:hover {
  color: #fff;
  background: rgba(255,255,255,0.1);
}

@media (max-width: 900px) {
  .footer-main,
  .footer-cols {
    grid-template-columns: 1fr;
  }

  .footer-main {
    gap: 44px;
  }
}

@media (max-width: 640px) {
  .footer-cta {
    padding: 82px 18px;
  }

  .footer-main {
    padding: 58px 18px;
  }

  .footer-bottom {
    padding: 22px 18px 42px;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue